import { render, staticRenderFns } from "./CustomFieldTextEditor.vue?vue&type=template&id=5a11421a&"
import script from "./CustomFieldTextEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldTextEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports